( function() {
  if (document.getElementById("FacetFiltersForm")) {
    const changePriceInput = el => {
      const rangeInput = document.querySelectorAll('.facets__price-slider .range-input'),
        priceInput = document.querySelectorAll('.facets__price .price-input'),
        range = document.querySelector('.facets__price-slider .slider .progress');
      let priceGap = 0;
      
      let minPrice = parseInt(priceInput[0].value) || 0,
        maxPrice = parseInt(priceInput[1].value) || priceInput[1].max;
      if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
        if (el.classList.contains('input-min')) {
          rangeInput[0].value = minPrice;
          range.style.left = ((minPrice / rangeInput[0].max) * 100) + '%';
        } else {
          rangeInput[1].value = maxPrice;
          range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + '%';
        }
      }
    };
    
    const changeRangeInput = (el, changePrice = true) => {
      const rangeInput = document.querySelectorAll('.facets__price-slider .range-input'),
        priceInput = document.querySelectorAll('.facets__price .price-input'),
        range = document.querySelector('.facets__price-slider .slider .progress');
      let priceGap = 0;
      
      let minVal = parseInt(rangeInput[0].value),
        maxVal = parseInt(rangeInput[1].value);
      if ((maxVal - minVal) < priceGap) {
        if (el.classList.contains('range-min')) {
          rangeInput[0].value = maxVal - priceGap;
        } else {
          rangeInput[1].value = minVal + priceGap;
        }
      } else {
        if (changePrice) {
          priceInput[0].value = minVal;
          priceInput[1].value = maxVal;
        }
        range.style.left = ((minVal / rangeInput[0].max) * 100) + '%';
        range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
      }
    };
    
    const initRangeSlider = () => {
      const priceSlider = document.querySelector('.facets__price-slider');
      
      if (priceSlider) {
        priceSlider.style.display = 'block';
        
        const rangeInput = document.querySelectorAll('.facets__price-slider .range-input');
        
        if (rangeInput) {
          rangeInput.forEach(el => {
            changeRangeInput(el, false);
          });
        }
      }
    };
    
    document.addEventListener('input', e => {
      if (e.target.classList.contains('facets-price-slider-input')) {
        if (e.target.classList.contains('price-input')) {
          changePriceInput(e.target);
        } else if (e.target.classList.contains('range-input')) {
          changeRangeInput(e.target);
        }
      }
    });
    
    initRangeSlider();
    
    const mutationOptions = {
      childList: true, //直接の子の変更を監視
      characterData: true,　 //文字の変化を監視
      characterDataOldValue: true,　//属性の変化前を記録
      attributes: true,　 //属性の変化を監視
      subtree: true //全ての子要素を監視
    };
    
    const mutationCallback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        initRangeSlider();
      }
    };
    
    const mutationTarget = document.querySelector('#FacetsWrapperDesktop details');
    
    if (mutationTarget) {
      const mutationObserver = new MutationObserver(mutationCallback);
      mutationObserver.observe(mutationTarget, mutationOptions);
    }
  }
}());

(function() {
  if ( document.body.classList.contains("template-index") ) {
    const stickyHeader = document.querySelector('sticky-header');
    const annoucementBar = document.querySelector('.announcement-bar-section');
    
    if (stickyHeader && annoucementBar) {
      const switchStickyHeaderTransparent = () => {
        const barClientRect = annoucementBar.getBoundingClientRect();
        
        if (barClientRect) {
          const y = barClientRect.y;
          const height = barClientRect.height;
          
          if (y + height < 0) {
            stickyHeader.classList.remove('header-transparent');
          } else {
            stickyHeader.classList.add('header-transparent');
          }
        }
      };
      
      const adjustStickyHeaderMargin = () => {
        const headerHeight = stickyHeader.offsetHeight;
        stickyHeader.style.marginBottom = (-1 * headerHeight) + "px";
      };
      
      const observer = new IntersectionObserver((entries) => {
        for (const e of entries) {
          switchStickyHeaderTransparent();
        }
      });
      
      observer.observe(annoucementBar);
      
      adjustStickyHeaderMargin();
      
      window.onresize = () => {
        adjustStickyHeaderMargin();
        switchStickyHeaderTransparent();
      };
    }
  }
})();

(function() {
  document.querySelectorAll(".footer-block__nav > li > span").forEach(el => {
    el.addEventListener('click', e => {
      console.log(0);
      const thisEl = e.target;
      
      if (thisEl.classList.contains('accordion')) {
        thisEl.classList.remove('accordion');
      } else {
        thisEl.classList.add('accordion');
      }
    });
  });
})();

(function() {
  const links = document.querySelectorAll('a');
  for (let i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
})();
